//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customer from '@/customer'

export default {
  name: 'scanPickClothes',
  data () {
    return {
      cid: 0,
      token: '',
      user: {},
      phone: '',
      banner: [],
      type: 0,
      list: [],
      number: 0,
      lastId: 0,
      pageFlag: 1,
      hasNext: 0,
      checkAllStatus: false,
      blankShow: false,
      blankText: '请输入手机号查询待取衣物',
      loading: false,
      tabs: [
        {key: 0, value: '待取衣物'},
        {key: 1, value: '全部衣物'}
      ]
    }
  },
  computed: {
    tokenKey () {
      return 'scan_token_' + customer.key
    }
  },
  created () {
    this.init()
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    init () {
      this.parseScene()
      if (!this.cid) {
        this.blankShow = true
        this.blankText = '二维码异常，缺少门店信息'
        return
      }
      this.getBanner()
    },
    parseScene () {
      const query = Object.assign({}, this.$route.query)
      const scene = query.scene ? decodeURIComponent(query.scene) : ''
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach((item) => {
          const arr = item.split('=')
          if (arr[0]) {
            query[arr[0]] = arr[1]
          }
        })
      }
      this.cid = parseInt(query.cid || 0)
    },
    getBanner () {
      this.$api.scanBanner({cid: this.cid, position: 2}, this.token).then((res) => {
        if (res && res.data && res.data.list) {
          this.banner = res.data.list
        }
      })
    },
    selectType (type) {
      this.type = type
      this.search()
    },
    search () {
      if (!this.phone) {
        this.$func.showToast('请输入手机号查询')
        return
      }
      this.pageFlag = 1
      this.lastId = 0
      this.list = []
      this.number = 0
      this.checkAllStatus = false
      this.getList()
    },
    getList () {
      if (this.loading || !this.phone) {
        return
      }
      this.loading = true
      this.$api.scanWaitPick({
        cid: this.cid,
        type: this.type,
        last_id: this.lastId,
        page_flag: this.pageFlag,
        phone: this.phone
      }, this.token).then((res) => {
        this.loading = false
        if (!res) {
          return
        }
        const data = res.data || []
        if (!this.lastId) {
          this.blankShow = data.length <= 0
          this.blankText = '暂无待取衣物'
        }
        this.hasNext = res.hasNext
        this.lastId = res.lastId
        data.forEach((item) => {
          item.checked = 0
          this.list.push(item)
        })
      }).catch(() => {
        this.loading = false
      })
    },
    checkAll () {
      this.checkAllStatus = !this.checkAllStatus
      this.list.forEach((item) => {
        item.checked = this.checkAllStatus ? 1 : 0
      })
      this.countNum()
    },
    check (index) {
      this.list[index].checked = this.list[index].checked ? 0 : 1
      this.checkAllStatus = this.list.length > 0 && this.list.every((item) => item.checked)
      this.countNum()
    },
    countNum () {
      this.number = this.list.filter((item) => item.checked).length
    },
    submit () {
      const ids = this.list.filter((item) => item.checked).map((item) => item.id)
      if (!ids.length) {
        this.$func.showToast('请选择衣物')
        return
      }
      this.$func.confirm('确认取衣？', '提示', () => {
        this.$api.scanPick({ids: ids.join(','), cid: this.cid, phone: this.phone}, this.token).then((res) => {
          if (res) {
            this.$func.showToast(res.msg || '取衣成功')
            this.search()
          }
        })
      })
    },
    onScroll () {
      if (!this.hasNext || this.loading) {
        return
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + clientHeight + 80 >= scrollHeight) {
        this.pageFlag = 2
        this.getList()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/scanPickClothes.vue